import { IUseListboxState, OptionsGroup, Option } from '../useListboxState';
export const treeToMap = (children, initialState) => {
  if (!Array.isArray(children)) return initialState;
  children.forEach(child => {
    const id = (Math.random() + 1).toString(36).substring(7);
    if (child.children) {
      treeToMap(child.children, {
        ...initialState,
        childIndex: 0
      });
      initialState.collectionGroups[id] = {
        heading: child.heading
      };
      initialState.groupsKeys[id] = child.children.map(item => item.id);
    }
    if (child.option) {
      initialState.childIndex = initialState.childIndex + 1;
      initialState.collectionOptions.set(child.id, {
        disabled: child.disabled,
        description: child.description,
        isVisible: true,
        label: child.option,
        posinset: initialState.childIndex
      });
      initialState.optionKeys.push(child.id);
      if (!child.disabled) {
        initialState.interactiveKeys.push(child.id);
      }
    }
  });
  return {
    collectionOptions: initialState.collectionOptions,
    collectionGroups: initialState.collectionGroups,
    groupsKeys: initialState.groupsKeys,
    interactiveKeys: initialState.interactiveKeys,
    optionKeys: initialState.optionKeys
  };
};